import { useEffect } from 'react'
import { assert } from 'lib/errors'

const useAssert = (condition, message) => {
    useEffect(() => {
        assert(condition, message)
    }, [condition, message])
}

export default useAssert
